// iPad keyboard: Safari doesn't shrink the page for it, it just covers the bottom. Track its height so scroll areas
// can pad below their content and the focused field is scrolled into view above it.
export function watchKeyboard() {
  const vv = window.visualViewport
  if (!vv) return
  const apply = () => {
    const kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop))
    document.documentElement.style.setProperty('--kb', kb + 'px')
    document.documentElement.classList.toggle('kb-open', kb > 80)
  }
  vv.addEventListener('resize', apply); vv.addEventListener('scroll', apply); apply()
  document.addEventListener('focusin', (e) => {
    const el = e.target as HTMLElement
    if (!(el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement)) return
    setTimeout(() => el.scrollIntoView({ block: 'center', behavior: 'smooth' }), 350)
  })
}
